import { render } from "./SelectColor.vue?vue&type=template&id=b043d39e&scoped=true"
import script from "./SelectColor.vue?vue&type=script&lang=js"
export * from "./SelectColor.vue?vue&type=script&lang=js"

import "./SelectColor.vue?vue&type=style&index=0&id=b043d39e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b043d39e"]])

export default __exports__